import { State } from "@progress/kendo-data-query";
import StoredDataState from "./interfaces/StoredDataState";
import moment from "moment";
import ColumnInfoDto from "./interfaces/dtos/ColumnInfoDto";
import DataSourceItem from "./interfaces/DataSourceItem";

export const parseDate = (dateString?: string): Date | null => {
  if (!dateString) {
    return null;
  }

  const timeOffset = new Date().getTimezoneOffset();
  const hours = -Math.trunc(timeOffset / 60);
  const minutes = Math.abs(timeOffset % 60);
  let hoursString;
  if (hours < -9) {
    hoursString = `${hours}`;
  } else if (hours < 0) {
    hoursString = `-0${-hours}`;
  } else if (hours < 10) {
    hoursString = `0${hours}`;
  } else {
    hoursString = `${hours}`;
  }
  const minutesString = minutes > 9 ? `${minutes}` : `0${minutes}`;
  const timeOffsetString = `${hoursString}:${minutesString}`;

  if (dateString.length === 10) {
    return new Date(`${dateString}T00:00:00.000${timeOffsetString}`);
  }

  if (dateString.length === 24) {
    return new Date(dateString.substring(0, 23) + timeOffsetString);
  }

  return new Date(dateString);
};

export const parseDataSource = (
  dataSource: DataSourceItem[],
  columns: ColumnInfoDto[]
) => {
  dataSource.forEach((source) => {
    columns.forEach((col) => {
      if (col.dataType === "Date") {
        const momentDate = moment(source[col.field]);
        source[col.field] = momentDate.isValid() ? momentDate.toDate() : null;
      }

      if (col.dataType === "DateTime") {
        source[col.field] = parseDate(source[col.field]);
      }
    });
  });

  return dataSource;
};

export const selectStoredDataState = (
  state: State | undefined
): StoredDataState => {
  if (!state) {
    return {};
  }
  return {
    filter: state.filter,
    sort: state.sort ?? [],
  };
};
